// Source: app/scripts/controllers/web-portal-home-page.js
/* global Auction */
Auction.controller('WebPortalHomePageController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  '$window',
  '$timeout',
  'settings',
  'SimplifiedProcedureValidation',
  'ModalScrollLock',
  'CustomsWarehouseFormHelpers',
  'ngTableParams',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages, $window, $timeout, settings, SimplifiedProcedureValidation, ModalScrollLock, CustomsWarehouseFormHelpers, ngTableParams) {

    $scope.assetsVersion = settings.version;

    $scope.onEntryDeclarationOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onEntryDeclarationOptionChange($scope, selectedField);
    };

    $scope.onDischargeDeclarationOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onDischargeDeclarationOptionChange($scope, selectedField);
    };

    $scope.onTransferInfoOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onTransferInfoOptionChange($scope, selectedField);
    };

    $scope.onWarehouseTypeOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onWarehouseTypeOptionChange($scope, selectedField);
    };

    var caseService = crudService('cases', {
      'getRegisteredUserCases': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/cases/by_registered_user'
      },
      'getRegisteredUserFilteredCases': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/cases/submit_filters'
      },
      'createGeneralCase': {
        method: 'POST',
        url: '/data/rest/general_cases/create_general_case'
      },
      'findIndividualStatusFromPersonalNumber': {
        method: 'GET',
        url: '/data/rest/registered_users/find_individual_from_personal_number'
      },
      'findCompanyStatusFromUniqueNumber': {
        method: 'GET',
        url: '/data/rest/registered_users/find_company_from_unique_number'
      },
      'submitGeneralCase': {
        method: 'POST',
        url: '/data/rest/general_cases/submit_general_case'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'integrate': {
        method: 'POST',
        url: '/data/rest/general_cases/integrate'
      },
      'cancelCase': {
        method: 'GET',
        url: '/data/rest/general_cases/cancel_case/:id'
      }
    });


    var individualService = crudService('individuals', {
      'save': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/complaint_cases/individuals'
      }
    });

    var companyService = crudService('companies', {
      'save': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/companies'
      }
    });

    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );

    var authorizationCaseService = crudService('authorization_cases', {
      'createAuthorizationCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/authorization_cases/create_authorization_case'
      },
      'submitAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_cases/submit_authorization_case'
      },
      'cancelAuthorizationCase': {
        method: 'GET',
        url: '/data/rest/authorization_cases/cancel_case/:id'
      },
      'findTariffByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/tariffs/by_code'
      },
      'createAuthorizationCaseForLicence': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/authorization_cases/create_authorization_case_for_licence'
      }
    });

    var complainCaseService = crudService('complainCase', {
      'allowComplainCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/complaint_cases/check_if_customs_declaration_can_be_added'
      },
      'createComplainCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/complaint_cases/create_customs_declaration_complaint_case'
      },
      'submitComplainCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/complaint_cases/submit_complaint_case'
      },
      'createComplainCaseDecision': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/complaint_cases/create_decision_complaint_case'
      },
      'cancelComplaintCase': {
        method: 'GET',
        url: '/data/rest/complaint_cases/cancel_case/:id'
      },
      'checkDecisionNumber': {
        method: 'POST',
        url: '/data/rest/complaint_cases/check_decision_number'
      }
    });

    var movementCertificateCaseService = crudService('movement_certificate_cases', {
      'createMovementCertificateCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/movement_certificate_cases/create_movement_certificate_case'
      },
      'submitMovementCertificateCase': {
        method: 'POST',
        url: '/data/rest/movement_certificate_cases/submit_movement_certificate_case'
      },
      'cancelMovementCertificateCase': {
        method: 'GET',
        url: '/data/rest/movement_certificate_cases/cancel_case/:id'
      },
      'loadCustomsDeclarationData': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/movement_certificate_cases/load_customs_declaration_data'
      }

    });

    var btiCaseService = crudService('bti_cases', {
      'createBTICase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/bti_cases/create_bti_case'
      },
      'submitBTICase': {
        method: 'POST',
        url: '/data/rest/bti_cases/submit_bti_case'
      },
      'cancelBTICase': {
        method: 'GET',
        url: '/data/rest/bti_cases/cancel_case/:id'
      }

    });

    var iprCaseService = crudService('ipr_cases', {
      'createIPRCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/ipr_cases/create_ipr_case'
      },
      'submitIPRCase': {
        method: 'POST',
        url: '/data/rest/ipr_cases/submit_ipr_case'
      },
      'cancelIPRCase': {
        method: 'GET',
        url: '/data/rest/ipr_cases/cancel_case/:id'
      }

    });

    var customsWarehouseCaseService = crudService('customs_warehouse_cases', {
      'createCustomsWarehouseCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/customs_warehouse_cases/create_customs_warehouse_case'
      },
      'submitCustomsWarehouseCase': {
        method: 'POST',
        url: '/data/rest/customs_warehouse_cases/submit_customs_warehouse_case'
      },
      'cancelCustomsWarehouseCase': {
        method: 'GET',
        url: '/data/rest/customs_warehouse_cases/cancel_case/:id'
      }

    });

    var simplifiedProcedureCaseService = crudService('simplified_procedure_cases', {
      'createSimplifiedProcedureCase': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/simplified_procedure_cases/create_simplified_procedure_case'
      },
      'submitSimplifiedProcedureCase': {
        method: 'POST',
        url: '/data/rest/simplified_procedure_cases/submit_simplified_procedure_case'
      },
      'cancelSimplifiedProcedureCase': {
        method: 'GET',
        url: '/data/rest/simplified_procedure_cases/cancel_case/:id'
      }

    });

    function lazyModal(createFn) {
      var instance;
      return {
        show: function () {
          if (!instance) {
            instance = createFn();
          }
          if (instance.$promise) {
            instance.$promise.then(function () {
              instance.show();
            });
          } else {
            instance.show();
          }
        },
        hide: function () {
          if (instance) {
            instance.hide();
          }
        }
      };
    }

    var rightScope = $scope.$new(true);
    var addOrEditRightDialog = lazyModal(function () {
      return $modal({
      scope: rightScope,
      template: 'forms/add_or_edit_ipr_rights.html',
      show: false,
      windowClass: 'my-small-modal'
      });
    });

    rightScope.$watch('rightEntity', function (newVal) {
      if (!newVal) return;

      var selectedGoods = [];

      // Поминуваме низ сите 45 полиња од HTML-от (referredItem1 до referredItem45)
      for (var i = 1; i <= 45; i++) {
        var propertyName = 'referredItem' + i;
        // Ако чекбоксот е штиклиран во rightEntity
        if (newVal[propertyName] === true) {
          selectedGoods.push(i);
        }
      }

      // Автоматски го пополнуваме referredList со броевите (пр. "1, 2, 5")
      // Ова веднаш ќе се рефлектира во input полето во HTML-от
      rightScope.rightEntity.referredList = selectedGoods.join(', ');

    }, true);

    var goodScope = $scope.$new(true);
    var addOrEditGoodDialog = lazyModal(function () {
      return $modal({
      scope: goodScope,
      template: 'forms/add_or_edit_ipr_goods.html',
      show: false,
      windowClass: 'my-large-modal'
      });
    });

    $scope.modalAddOrEditWarehouseGood = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'forms/add_or_edit_warehouse_goods.html',
      show: false,
      windowClass: 'my-large-modal'
      });
    });

    $scope.modalAddOrEditWarehouseLocation = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'forms/add_or_edit_warehouse_location.html',
      show: false,
      windowClass: 'my-large-modal'
      });
    });

    $scope.modalAddOrEditSimplifiedProcedureGood = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'forms/add_or_edit_simplified_procedure_goods.html?version=' + settings.version,
      show: false,
      windowClass: 'my-large-modal'
      });
    });

    ModalScrollLock.bindScope($scope);

    $scope.ensureCustomsWarehouseGoodsList = function () {
      if (!$scope.customsWarehouseCaseEntity) {
        $scope.customsWarehouseCaseEntity = {};
      }
      if (!$scope.customsWarehouseCaseEntity.customsWarehouseGoodsList) {
        $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = [];
      }
    };

    $scope.ensureCustomsWarehouseLocationList = function () {
      if (!$scope.customsWarehouseCaseEntity) {
        $scope.customsWarehouseCaseEntity = {};
      }
      if (!$scope.customsWarehouseCaseEntity.customsWarehouseLocationList) {
        $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = [];
      }
    };

    $scope.searchTariffByCodeForWarehouseGood = function (code) {
      authorizationCaseService.findTariffByCode({code: code}, function (data) {
        if (data.id) {
          $scope.warehouseGoodEntity.tariff = data;
          $scope.warehouseGoodEntity.tariffCode = code;
          $scope.warehouseGoodEntity.tariffDescription = data.labelSQ;
          $scope.foundWarehouseTariffMessage = '';
        } else {
          $scope.warehouseGoodEntity.tariff = null;
          $scope.warehouseGoodEntity.tariffDescription = null;
          $scope.foundWarehouseTariffMessage = 'portal.tariff_not_found';
        }
      });
    };

    $scope.saveWarehouseGoodFromModal = function () {
      var entity = $scope.warehouseGoodEntity;
      if (!entity.tariff || !entity.tariff.id) {
        Messages.error('portal.invalid_tariff');
        return;
      }

      var good = {
        tariffCode: entity.tariffCode,
        tariffDescription: entity.tariffDescription || entity.tariff.labelSQ,
        quantity: entity.quantity,
        value: entity.value,
        tariff: entity.tariff
      };

      $scope.ensureCustomsWarehouseGoodsList();

      if ($scope.onEditWarehouseGood && $scope.editingWarehouseGoodIndex !== -1) {
        angular.copy(good, $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList[$scope.editingWarehouseGoodIndex]);
      } else {
        $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList.push(good);
      }

      Messages.saved();
      $scope.modalAddOrEditWarehouseGood.hide();
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.warehouseGoodEntity = {};
      $scope.foundWarehouseTariffMessage = '';
    };

    $scope.cancelWarehouseGoodModal = function () {
      $scope.modalAddOrEditWarehouseGood.hide();
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.warehouseGoodEntity = {};
      $scope.foundWarehouseTariffMessage = '';
    };

    $scope.addNewCustomsWarehouseLocation = function () {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseLocationList();
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.warehouseLocationEntity = {};
      $scope.modalAddOrEditWarehouseLocation.show();
    };

    $scope.editCustomsWarehouseLocation = function (index) {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseLocationList();
      $scope.onEditWarehouseLocation = true;
      $scope.editingWarehouseLocationIndex = index;
      $scope.warehouseLocationEntity = angular.copy($scope.customsWarehouseCaseEntity.customsWarehouseLocationList[index]);
      $scope.modalAddOrEditWarehouseLocation.show();
    };

    $scope.removeCustomsWarehouseLocation = function (index) {
      $scope.customsWarehouseCaseEntity.customsWarehouseLocationList.splice(index, 1);
    };

    $scope.saveWarehouseLocationFromModal = function () {
      var entity = $scope.warehouseLocationEntity;
      var location = {
        address: entity.address,
        streetNumber: entity.streetNumber,
        place: entity.place
      };

      $scope.ensureCustomsWarehouseLocationList();

      if ($scope.onEditWarehouseLocation && $scope.editingWarehouseLocationIndex !== -1) {
        angular.copy(location, $scope.customsWarehouseCaseEntity.customsWarehouseLocationList[$scope.editingWarehouseLocationIndex]);
      } else {
        $scope.customsWarehouseCaseEntity.customsWarehouseLocationList.push(location);
      }

      Messages.saved();
      $scope.modalAddOrEditWarehouseLocation.hide();
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.warehouseLocationEntity = {};
    };

    $scope.cancelWarehouseLocationModal = function () {
      $scope.modalAddOrEditWarehouseLocation.hide();
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.warehouseLocationEntity = {};
    };

    $scope.ensureSimplifiedProcedureGoodsList = function () {
      if (!$scope.simplifiedProcedureCaseEntity) {
        $scope.simplifiedProcedureCaseEntity = {};
      }
      if (!$scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList) {
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = [];
      }
    };

    $scope.searchTariffByCodeForSimplifiedProcedureGood = function (code) {
      authorizationCaseService.findTariffByCode({code: code}, function (data) {
        if (data.id) {
          $scope.simplifiedProcedureGoodEntity.tariff = data;
          $scope.simplifiedProcedureGoodEntity.tariffCode = code;
          $scope.simplifiedProcedureGoodEntity.tariffDescription = data.labelSQ;
          $scope.foundSimplifiedProcedureTariffMessage = '';
        } else {
          $scope.simplifiedProcedureGoodEntity.tariff = null;
          $scope.simplifiedProcedureGoodEntity.tariffDescription = null;
          $scope.foundSimplifiedProcedureTariffMessage = 'portal.tariff_not_found';
        }
      });
    };

    $scope.saveSimplifiedProcedureGoodFromModal = function () {
      var entity = $scope.simplifiedProcedureGoodEntity;
      if (!entity.tariff || !entity.tariff.id) {
        Messages.error('portal.invalid_tariff');
        return;
      }

      var good = {
        tariffCode: entity.tariffCode,
        tariffDescription: entity.tariffDescription || entity.tariff.labelSQ,
        goodCustomsProcedures: entity.goodCustomsProcedures,
        countries: entity.countries,
        codeOfProcedures: entity.codeOfProcedures,
        parities: entity.parities,
        packagingMethods: entity.packagingMethods,
        exporter: entity.exporter,
        tariff: entity.tariff
      };

      $scope.ensureSimplifiedProcedureGoodsList();

      if ($scope.onEditSimplifiedProcedureGood && $scope.editingSimplifiedProcedureGoodIndex !== -1) {
        angular.copy(good, $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList[$scope.editingSimplifiedProcedureGoodIndex]);
      } else {
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList.push(good);
      }

      Messages.saved();
      $scope.modalAddOrEditSimplifiedProcedureGood.hide();
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      $scope.simplifiedProcedureGoodEntity = {};
      $scope.foundSimplifiedProcedureTariffMessage = '';
    };

    $scope.cancelSimplifiedProcedureGoodModal = function () {
      $scope.modalAddOrEditSimplifiedProcedureGood.hide();
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      $scope.simplifiedProcedureGoodEntity = {};
      $scope.foundSimplifiedProcedureTariffMessage = '';
    };

    $scope.addNewSimplifiedProcedureGood = function () {
      $scope.ensureSimplifiedProcedureGoodsList();
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      $scope.simplifiedProcedureGoodEntity = {goodCustomsProcedures: [], countries: [], codeOfProcedures: [], parities: [], packagingMethods: []};
      $scope.foundSimplifiedProcedureTariffMessage = '';
      $scope.modalAddOrEditSimplifiedProcedureGood.show();
    };

    $scope.editSimplifiedProcedureGood = function (index) {
      $scope.ensureSimplifiedProcedureGoodsList();
      $scope.onEditSimplifiedProcedureGood = true;
      $scope.editingSimplifiedProcedureGoodIndex = index;
      $scope.simplifiedProcedureGoodEntity = angular.copy($scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList[index]);
      $scope.simplifiedProcedureGoodEntity.goodCustomsProcedures = $scope.simplifiedProcedureGoodEntity.goodCustomsProcedures || [];
      $scope.simplifiedProcedureGoodEntity.countries = $scope.simplifiedProcedureGoodEntity.countries || [];
      $scope.simplifiedProcedureGoodEntity.codeOfProcedures = $scope.simplifiedProcedureGoodEntity.codeOfProcedures || [];
      $scope.simplifiedProcedureGoodEntity.parities = $scope.simplifiedProcedureGoodEntity.parities || [];
      $scope.simplifiedProcedureGoodEntity.packagingMethods = $scope.simplifiedProcedureGoodEntity.packagingMethods || [];
      $scope.foundSimplifiedProcedureTariffMessage = '';
      if ($scope.simplifiedProcedureGoodEntity.tariffCode) {
        authorizationCaseService.findTariffByCode({code: $scope.simplifiedProcedureGoodEntity.tariffCode}, function (data) {
          if (data.id) {
            $scope.simplifiedProcedureGoodEntity.tariff = data;
          }
        });
      }
      $scope.modalAddOrEditSimplifiedProcedureGood.show();
    };

    $scope.removeSimplifiedProcedureGoods = function (index) {
      $scope.ensureSimplifiedProcedureGoodsList();
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList.splice(index, 1);
    };

    function initEntity() {
      $scope.onEditRight = false;
      $scope.editingRightIndex = -1;
      $scope.onEditGood = false;
      $scope.editingGoodIndex = -1;
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.onEditSimplifiedProcedureGood = false;
      $scope.editingSimplifiedProcedureGoodIndex = -1;
      if (!$scope.entity) {
        $scope.filter = {};
        if (!$scope.$root.user) {
          $window.setTimeout(function() {
            if ($scope.$root.user.intermediary) {
              $scope.recordsTab = 1;
            } else {
              $scope.recordsTab = 2;
            }
            $scope.documentList = [];
            $scope.forSelf = 1;
            $scope.forIndividual = 0;
            $scope.forCompany = 0;
            $scope.individual = {};
            $scope.company = {};
            $scope.allowIndividualEdit = false;
            $scope.allowCompanyEdit = false;

            $scope.forSad = 1;
            $scope.forDecision = 0;


            $scope.forAuthorization = 1;
            $scope.forLicence = 0;

            $scope.entity = {};
            $scope.entity.generalCase = {};

            $scope.authorizationCaseEntity = {};
            $scope.authorizationCaseEntity.authorizationCase = {};
            $scope.authorizationCaseEntity.authorizationTariffList = [];
            $scope.authorizationCaseEntity.authorization = {};

            $scope.authorizationTariff = {};
            $scope.foundAuthorizationTafiff = "";

            $scope.authorizationCaseLicenceEntity = {};
            $scope.authorizationCaseLicenceEntity.licence = {};
            $scope.authorizationCaseLicenceEntity.authorizationCase = {};

            $scope.recordsSubTab = 1;

            $scope.search = {};
            $scope.search.fiscalNumber = "";
            $scope.search.personalNumber = "";
            $scope.search.companyUniqueNumber = "";

            $scope.showAddDocument = false;

            $scope.documentDto = {};
            $scope.documentDto.portalDocument = {};
            $scope.documentDto.file = {};

            $scope.complainCaseEntity = {};
            $scope.complainCaseEntity.complaintCase = {};
            $scope.sad = {};
            $scope.complainCaseEntity.declarations = [];

            $scope.complaintCaseDecisionEntity = {};
            $scope.complaintCaseDecisionEntity.decision = {};
            $scope.complaintCaseDecisionEntity.complaintCase = {};

            $scope.disableDecisionChanges = true;
            $scope.showDecisionTypeCombo = true;

            $scope.isAllowed = "";
            if($scope.entity && $scope.complainCaseEntity && $scope.authorizationCaseEntity){
              $scope.initialized = true;
            }else{
              $window.setTimeout(function() {
                $scope.initialized = true;

              },2000)
            }

            $scope.movementCertificateCaseEntity = {};
            $scope.movementCertificateCaseEntity.movementCertificateCase = {};
            $scope.movementCertificateCaseEntity.movementCertificateGoodsList = [];
            $scope.movementCertificateCaseEntity.movementCertificateInvoicesList = [];
            $scope.movementCertificateCaseEntity.movementCertificate = {};
            $scope.movementCertificateGoods = {};
            $scope.movementCertificateInvoices ={};

            $scope.btiCaseEntity = {};
            $scope.btiCaseEntity.btiCase = {};
            $scope.btiCaseEntity.bti = {};

            $scope.iprCaseEntity = {};
            $scope.iprCaseEntity.iprCase = {};
            $scope.iprCaseEntity.iprRightsList = [];
            $scope.iprCaseEntity.iprGoodsList = [];
            $scope.iprCaseEntity.ipr = {};
            $scope.iprRights = {};
            $scope.iprGoods = {};

            $scope.customsWarehouseCaseEntity = {};
            $scope.customsWarehouseCaseEntity.customsWarehouseCase = {};
            $scope.customsWarehouseCaseEntity.customsWarehouse = {};
            $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = [];
            $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = [];
            $scope.warehouseGoods = {};

            $scope.simplifiedProcedureCaseEntity = {};
            $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase = {};
            $scope.simplifiedProcedureCaseEntity.simplifiedProcedure = {};
            $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = [];

          }, 2000);
        }else {
          if ($scope.$root.user.intermediary) {
            $scope.recordsTab = 1;
          } else {
            $scope.recordsTab = 2;
          }
          $scope.documentList = [];
          $scope.forSelf = 1;
          $scope.forIndividual = 0;
          $scope.forCompany = 0;
          $scope.individual = {};
          $scope.company = {};
          $scope.allowIndividualEdit = false;
          $scope.allowCompanyEdit = false;

          $scope.forSad = 1;
          $scope.forDecision = 0;


          $scope.forAuthorization = 1;
          $scope.forLicence = 0;

          $scope.entity = {};
          $scope.entity.generalCase = {};

          $scope.authorizationCaseEntity = {};
          $scope.authorizationCaseEntity.authorizationCase = {};
          $scope.authorizationCaseEntity.authorizationTariffList = [];
          $scope.authorizationCaseEntity.authorization = {};

          $scope.authorizationTariff = {};
          $scope.foundAuthorizationTafiff = "";

          $scope.authorizationCaseLicenceEntity = {};
          $scope.authorizationCaseLicenceEntity.licence = {};
          $scope.authorizationCaseLicenceEntity.authorizationCase = {};

          $scope.recordsSubTab = 1;

          $scope.search = {};
          $scope.search.fiscalNumber = "";
          $scope.search.personalNumber = "";
          $scope.search.companyUniqueNumber = "";

          $scope.showAddDocument = false;

          $scope.documentDto = {};
          $scope.documentDto.portalDocument = {};
          $scope.documentDto.file = {};

          $scope.complainCaseEntity = {};
          $scope.complainCaseEntity.complaintCase = {};
          $scope.sad = {};
          $scope.complainCaseEntity.declarations = [];

          $scope.complaintCaseDecisionEntity = {};
          $scope.complaintCaseDecisionEntity.decision = {};
          $scope.complaintCaseDecisionEntity.complaintCase = {};

          $scope.disableDecisionChanges = false;
          $scope.showDecisionTypeCombo = false;

          $scope.isAllowed = "";
          if($scope.entity && $scope.complainCaseEntity && $scope.authorizationCaseEntity){
            $scope.initialized = true;
          }else{
            $window.setTimeout(function() {
              $scope.initialized = true;

            },2000)
          }
          $scope.movementCertificateCaseEntity = {};
          $scope.movementCertificateCaseEntity.movementCertificateCase = {};
          $scope.movementCertificateCaseEntity.movementCertificateGoodsList = [];
          $scope.movementCertificateCaseEntity.movementCertificateInvoicesList = [];
          $scope.movementCertificateCaseEntity.movementCertificate = {};
          $scope.movementCertificateGoods = {};
          $scope.movementCertificateInvoices ={};

          $scope.btiCaseEntity = {};
          $scope.btiCaseEntity.btiCase = {};
          $scope.btiCaseEntity.bti = {};

          $scope.iprCaseEntity = {};
          $scope.iprCaseEntity.iprCase = {};
          $scope.iprCaseEntity.iprRightsList = [];
          $scope.iprCaseEntity.iprGoodsList = [];
          $scope.iprCaseEntity.ipr = {};
          $scope.iprRights = {};
          $scope.iprGoods = {};

          $scope.customsWarehouseCaseEntity = {};
          $scope.customsWarehouseCaseEntity.customsWarehouseCase = {};
          $scope.customsWarehouseCaseEntity.customsWarehouse = {};
          $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = [];
          $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = [];
          $scope.warehouseGoods = {};

          $scope.simplifiedProcedureCaseEntity = {};
          $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase = {};
          $scope.simplifiedProcedureCaseEntity.simplifiedProcedure = {};
          $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = [];
        }
        }
        if($scope.entity && $scope.complainCaseEntity && $scope.authorizationCaseEntity){
          $scope.initialized = true;
        }else{
          $window.setTimeout(function() {
            $scope.initialized = true;

          },2000)
        }
    }

    initEntity();


    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };
      $scope.recordsTab = rt;
    };


    if ($routeParams && $routeParams.recordsSubTab) {
      $scope.recordsSubTab = $routeParams.recordsSubTab;
    }

    $scope.activateSubTab = function (rt) {
      var search = {
        recordsSubTab: rt
      };

      if ($routeParams && $routeParams.tab) {
        search.tab = $routeParams.tab;
      }
      $scope.recordsSubTab = rt;
      $location.search(search);
    };


    $scope.createGeneralCase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_general_case");
      $scope.about = {};
      $scope.entity.generalCase.caseType = 'GENERAL';
      $scope.entity.generalCase.caseStatus = 'DRAFT';

    };

    $scope.createComplainCase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_complain_case");

    };


    $scope.modalCreateGeneralCase = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'forms/case/create_general_case.html',
      show: false
      });
    });

    $scope.modalEditGeneralCase = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'forms/case/create_general_case_edit.html',
      show: false
      });
    });

    $scope.saveNewGeneralCase = function () {

      $scope.entity.generalCase.caseType = 'GENERAL';
      $scope.entity.generalCase.caseStatus = 'DRAFT';

      caseService.createGeneralCase($scope.entity, function (data) {
        $scope.entity.generalCase = data;

        //iskomentirano za test
        // $scope.activateTab(3);

        $location.path("/web_portal/web_portal_home_page/edit_general_case/" + data.id);

      })
    };

    $scope.setAbout = function (data) {
      if (data == 1) {
        $scope.forSelf = 1;
        $scope.forIndividual = 0;
        $scope.forCompany = 0;
      } else if (data == 2) {
        $scope.forSelf = 0;
        $scope.forIndividual = 1;
        $scope.forCompany = 0;

      } else {
        $scope.forSelf = 0;
        $scope.forIndividual = 0;
        $scope.forCompany = 1;
      }
    };


    $scope.setComplainCase = function (data) {
      if (data == 1) {
        $scope.forSad = 1;
        $scope.forDecision = 0;
      } else {
        $scope.forSad = 0;
        $scope.forDecision = 1;
      }
    };

    $scope.setAuthorizationCase = function (data) {
      if (data == 1) {
        $scope.forAuthorization = 1;
        $scope.forLicence = 0;
      } else {
        $scope.forAuthorization = 0;
        $scope.forLicence = 1;
      }
    };


    $scope.findIndividualInfoFromPersonalNumber = function (personalNumber) {
      $scope.individual = {};
      $scope.individual.personalNumber = personalNumber;
      caseService.findIndividualStatusFromPersonalNumber({personalNumber: personalNumber}, function (data) {
        if (data.existsInDatabase) {
          $scope.individual = data.individual;
          // $scope.entity.aboutIndividual = data.individual;
          // $scope.aboutIndividual = data.individual;
        }
        if (data.hasUser) {
          $scope.allowIndividualEdit = false;
        } else {
          $scope.allowIndividualEdit = true;
        }

      })
    };

    $scope.findCompanyInfoFromUniqueNumber = function (companyUniqueNumber) {
      $scope.company = {};
      $scope.company.companyUniqueNumber = companyUniqueNumber;
      $scope.search.companyUniqueNumber = companyUniqueNumber || "";

      caseService.findCompanyStatusFromUniqueNumber({companyUniqueNumber: companyUniqueNumber}, function (data) {
        if (data.existsInDatabase) {
          $scope.company = data.company;
          if (data.company && data.company.companyUniqueNumber) {
            $scope.search.companyUniqueNumber = data.company.companyUniqueNumber;
          }
        }
        if (data.hasUser) {
          $scope.allowCompanyEdit = false;
        } else {
          $scope.allowCompanyEdit = true;
        }

      })
    };


    $scope.goToStepTwo = function (individual, forIndividual, company, forCompany, allowIndividualEdit, allowCompanyEdit) {
      var currentRecordTab = $scope.recordsTab;
      var nextRecordTab = currentRecordTab+1;

      $scope.activateTab(nextRecordTab);
      // $scope.entity = {};
      if (forIndividual) {
        $scope.entity.generalCase.aboutIndividual = individual;
        $scope.entity.generalCase.aboutCompany = {};
        $scope.authorizationCaseEntity.authorizationCase.aboutIndividual = individual;
        $scope.authorizationCaseEntity.authorizationCase.aboutCompany = {};
        $scope.complainCaseEntity.complaintCase.aboutIndividual = individual;
        $scope.complainCaseEntity.complaintCase.aboutCompany = {};
        $scope.complaintCaseDecisionEntity.complaintCase.aboutIndividual = individual;
        $scope.complaintCaseDecisionEntity.complaintCase.aboutCompany = {};
        $scope.movementCertificateCaseEntity.movementCertificateCase.aboutIndividual = individual;
        $scope.movementCertificateCaseEntity.movementCertificateCase.aboutCompany = {};
        $scope.btiCaseEntity.btiCase.aboutIndividual = individual;
        $scope.btiCaseEntity.btiCase.aboutCompany = {};
        $scope.iprCaseEntity.iprCase.aboutIndividual = individual;
        $scope.iprCaseEntity.iprCase.aboutCompany = {};
        $scope.customsWarehouseCaseEntity.customsWarehouseCase.aboutIndividual = individual;
        $scope.customsWarehouseCaseEntity.customsWarehouseCase.aboutCompany = {};
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.aboutIndividual = individual;
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.aboutCompany = {};
      }
      if (forCompany) {
        $scope.entity.generalCase.aboutCompany = company;
        $scope.entity.generalCase.aboutIndividual = {};
        $scope.authorizationCaseEntity.authorizationCase.aboutCompany = company;
        $scope.authorizationCaseEntity.authorizationCase.aboutIndividual = {};
        $scope.complainCaseEntity.complaintCase.aboutIndividual = {};
        $scope.complainCaseEntity.complaintCase.aboutCompany = company;
        $scope.complaintCaseDecisionEntity.complaintCase.aboutIndividual = {};
        $scope.complaintCaseDecisionEntity.complaintCase.aboutCompany = company;
        $scope.movementCertificateCaseEntity.movementCertificateCase.aboutIndividual = {};
        $scope.movementCertificateCaseEntity.movementCertificateCase.aboutCompany = company;
        $scope.btiCaseEntity.btiCase.aboutIndividual = {};
        $scope.btiCaseEntity.btiCase.aboutCompany = company;
        $scope.iprCaseEntity.iprCase.aboutIndividual = {};
        $scope.iprCaseEntity.iprCase.aboutCompany = company;
        $scope.customsWarehouseCaseEntity.customsWarehouseCase.aboutIndividual = {};
        $scope.customsWarehouseCaseEntity.customsWarehouseCase.aboutCompany = company;
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.aboutIndividual = {};
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.aboutCompany = company;
      }

      $scope.entity.forCompany = forCompany;
      $scope.entity.forIndividual = forIndividual;
      $scope.entity.allowIndividualEdit = allowIndividualEdit;
      $scope.entity.allowCompanyEdit = allowCompanyEdit;

      $scope.authorizationCaseEntity.forCompany = forCompany;
      $scope.authorizationCaseEntity.forIndividual = forIndividual;
      $scope.authorizationCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.authorizationCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.complainCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.complainCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.complainCaseEntity.forCompany = forCompany;
      $scope.complainCaseEntity.forIndividual = forIndividual;
      $scope.complaintCaseDecisionEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.complaintCaseDecisionEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.complaintCaseDecisionEntity.forCompany = forCompany;
      $scope.complaintCaseDecisionEntity.forIndividual = forIndividual;
      $scope.movementCertificateCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.movementCertificateCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.movementCertificateCaseEntity.forCompany = forCompany;
      $scope.movementCertificateCaseEntity.forIndividual = forIndividual;
      $scope.btiCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.btiCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.btiCaseEntity.forCompany = forCompany;
      $scope.btiCaseEntity.forIndividual = forIndividual;
      $scope.iprCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.iprCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.iprCaseEntity.forCompany = forCompany;
      $scope.iprCaseEntity.forIndividual = forIndividual;
      $scope.customsWarehouseCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.customsWarehouseCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.customsWarehouseCaseEntity.forCompany = forCompany;
      $scope.customsWarehouseCaseEntity.forIndividual = forIndividual;
      $scope.simplifiedProcedureCaseEntity.allowIndividualEdit = allowIndividualEdit;
      $scope.simplifiedProcedureCaseEntity.allowCompanyEdit = allowCompanyEdit;
      $scope.simplifiedProcedureCaseEntity.forCompany = forCompany;
      $scope.simplifiedProcedureCaseEntity.forIndividual = forIndividual;
    };

    var counter = 0;
    $scope.allowComplaintCase = true;
    $scope.addSad = function (sad, forSad) {

      $scope.showTable = 1;
      if (forSad) {
        sad.complaintCase = $scope.complainCaseEntity.complaintCase;
        if($scope.forCompany){
          sad.complaintCase.aboutIndividual = null;
        }else{
          sad.complaintCase.aboutCompany = null;
        }
        complainCaseService.allowComplainCase(sad, function (data) {
          $scope.isAllowed = data.value;

          if ($scope.isAllowed === true) {
            $scope.allowComplaintCase = true;
            $scope.complainCaseEntity.declarations.push(sad);
            // $scope.complainCaseEntity.sadList[0] = sad.declarationOffice;
            // $scope.complainCaseEntity.sadList[0] = sad.declarationYear;
            counter = counter + 1;
            $scope.sad = {};
          } else {
            $scope.allowComplaintCase = false;
            Messages.error('error', 'input is not valid');
          }
        });
      }

      $scope.entity.forSad = forSad;


    };


    $scope.showDecisionType = false;

    $scope.checkDecisionNumber = function (decisionNumber) {

      var decision = {};
      decision.decisionNumber = decisionNumber;
      decision.complaintCase = $scope.complaintCaseDecisionEntity.complaintCase;
      complainCaseService.checkDecisionNumber(decision, function (data) {
        $scope.decisionTypes = data.decisionType;
        $scope.complaintCaseDecisionEntity.decision.decisionType = data.decisionType;


        if($scope.decisionTypes != null){
          $scope.disableDecisionChanges = true;
          $scope.showDecisionTypeCombo = true;
        }else {
          $scope.disableDecisionChanges = false;
          $scope.showDecisionTypeCombo = true;
        }

      });
    };




    $scope.goBack = function () {
      var currentRecordTab = $scope.recordsTab;
      var previousRecordTab = currentRecordTab-1;
      $scope.activateTab(previousRecordTab);
    };


    $scope.createOrEditIndividual = function () {
      individualService.save($scope.individual, function (data) {
        $scope.individual = data;
        $scope.aboutIndividual = data;
      })

    };


    $scope.createOrEditCompany = function () {
      companyService.save($scope.company, function (data) {
        $scope.company = data;
        $scope.aboutCompany = data;
      })

    };

    function isCasesListPage() {
      var path = $location.path();
      return path === '/web_portal/web_portal_home_page'
        || path === '/ecounter_home'
        || path === '/web_portal/ecounter_home';
    }

    $scope.cases = [];
    $scope.table = new ngTableParams({
      page: 1,
      count: 50
    }, {
      counts: [25, 50, 100],
      getData: function ($defer, params) {
        var data = $scope.cases || [];
        params.total(data.length);
        $defer.resolve(data.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      }
    });

    function setCasesList(data) {
      $scope.cases = data || [];
      $scope.table.page(1);
      $scope.table.reload();
    }

    function load() {
      caseService.getRegisteredUserCases(function (data) {
        setCasesList(data);
      });
    }

    if (isCasesListPage()) {
      $scope.filter = $scope.filter || {};
      load();
    }


    $scope.cancel = function () {
      $location.path("/web_portal/web_portal_home_page");
    };


    $scope.openSubmitForm = function(portalCase){
      $scope.portalCase = portalCase;
      $scope.modalSubmitCaseConfirm.show();
    };

    $scope.submitPortalCase = function (portalCase) {
      if (portalCase.caseType == 'GENERAL') {
        caseService.submitGeneralCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'COMPLAINT') {
        complainCaseService.submitComplainCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'AUTHORIZATION') {
        authorizationCaseService.submitAuthorizationCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'MOVEMENT_CERTIFICATE') {
        movementCertificateCaseService.submitMovementCertificateCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'BTI') {
        btiCaseService.submitBTICase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'IPR') {
        iprCaseService.submitIPRCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'CUSTOMS_WAREHOUSE') {
        console.log("customs warehouse");
        customsWarehouseCaseService.submitCustomsWarehouseCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }
      if (portalCase.caseType == 'SIMPLIFIED_PROCEDURE') {
        simplifiedProcedureCaseService.submitSimplifiedProcedureCase(portalCase.id, function (data) {
          Messages.saved();
          load();
          $scope.modalSubmitCaseConfirm.hide();
          $scope.viewGeneralCase(portalCase);
        })
      }

      // $scope.viewGeneralCase(portalCase);
      $scope.modalSubmitCaseConfirm.hide();
    };

    $scope.showAddNewDocumentForm = function () {


      $scope.documentDto.portalDocument.aboutCase = $scope.entity.generalCase;
      $scope.showAddDocument = true;
    };

    $scope.editGeneralCase = function (portalCase) {
      if (portalCase.caseType == 'GENERAL') {
        $location.path("/web_portal/web_portal_home_page/edit_general_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'COMPLAINT') {
        $location.path("/web_portal/web_portal_home_page/edit_complaint_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'AUTHORIZATION') {
        $location.path("/web_portal/web_portal_home_page/edit_authorization_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'MOVEMENT_CERTIFICATE') {
        $location.path("/web_portal/web_portal_home_page/edit_movement_certificate_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'BTI') {
        $location.path("/web_portal/web_portal_home_page/edit_bti_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'IPR') {
        $location.path("/web_portal/web_portal_home_page/edit_ipr_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'CUSTOMS_WAREHOUSE') {
        $location.path("/web_portal/web_portal_home_page/edit_customs_warehouse_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'SIMPLIFIED_PROCEDURE') {
        $location.path("/web_portal/web_portal_home_page/edit_simplified_procedure_case/" + portalCase.id);
      }
    };


    $scope.viewGeneralCase = function (portalCase) {
      if (portalCase.caseType == 'GENERAL') {
        $location.path("/web_portal/web_portal_home_page/view_general_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'COMPLAINT') {
        $location.path("/web_portal/web_portal_home_page/view_complaint_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'AUTHORIZATION') {
        $location.path("/web_portal/web_portal_home_page/view_authorization_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'MOVEMENT_CERTIFICATE') {
        $location.path("/web_portal/web_portal_home_page/view_movement_certificate_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'BTI') {
        $location.path("/web_portal/web_portal_home_page/view_bti_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'IPR') {
        $location.path("/web_portal/web_portal_home_page/view_ipr_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'CUSTOMS_WAREHOUSE') {
        $location.path("/web_portal/web_portal_home_page/view_customs_warehouse_case/" + portalCase.id);
      }
      if (portalCase.caseType == 'SIMPLIFIED_PROCEDURE') {
        $location.path("/web_portal/web_portal_home_page/view_simplified_procedure_case/" + portalCase.id);
      }
    };

    $scope.savePortalDocument = function () {

      caseService.getPortalDocumentsForCase({id: $scope.entity.generalCase.id}, function (data) {
        $scope.documentList = data;
      });
      $scope.showAddDocument = false;

      $scope.documentDto = {};
      $scope.documentDto.portalDocument = {};
      $scope.documentDto.file = {};
    };

    $scope.downloadDocument = function (portalDocument) {
      Downloader.download('/data/rest/portal_attachments/get/' + portalDocument.id);
    };
    $scope.modalAddOrEditForumMessage = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/add_or_edit_forum_message.html',
      show: false
      });
    });

    $scope.modalSubmitCaseConfirm = lazyModal(function () {
      return $modal({
      scope: $scope,
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/submit_case_confirm.html',
      show: false
      });
    });

    $scope.modalChooseAuthorizationType = lazyModal(function () {
      return $modal({
        scope: $scope,
        template: 'forms/modals/choose_authorization_type.html?version=' + $scope.assetsVersion,
        show: false
      });
    });

    $scope.openAuthorizationTypeChoice = function () {
      $scope.modalChooseAuthorizationType.show();
    };

    $scope.chooseAuthorizationType = function (type) {
      $scope.modalChooseAuthorizationType.hide();
      if (type === 'AUTHORIZATION') {
        $scope.createAuthorizationCase();
      } else if (type === 'CUSTOMS_WAREHOUSE') {
        $scope.createCustomsWarehouseCase();
      } else if (type === 'SIMPLIFIED_PROCEDURE') {
        $scope.createSimplifiedProcedureCase();
      }
    };


    $scope.openCaseForum = function (portalCase) {
      forumService.getForumMessagesForCase({id: portalCase.forum.id}, function (data) {
        $scope.forumMessagesList = data;
        $scope.newForumMessage = {};
        $scope.forum = portalCase.forum;
        $scope.modalAddOrEditForumMessage.show();
      });

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };

    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };


    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.integrate = function () {
      caseService.integrate();
    };

    $scope.submitFilters = function () {
      var caseSubTypeId = 0;
      if (!$scope.filter.type) {
        $scope.filter.type = "";
      }
      if (!$scope.filter.status) {
        $scope.filter.status = "";
      }
      if ($scope.filter.subType) {
        caseSubTypeId = $scope.filter.subType.id;
      }
      if (!$scope.filter.company) {
        $scope.filter.company = "";
      }
      if (!$scope.filter.individual) {
        $scope.filter.individual = "";
      }
      caseService.getRegisteredUserFilteredCases({
        status: $scope.filter.status,
        type: $scope.filter.type,
        subTypeId: caseSubTypeId,
        company: $scope.filter.company,
        individual: $scope.filter.individual

      }, function (data) {
        setCasesList(data);
      })
    };


    $scope.cancelCase = function (portalCase) {
      var caseSubTypeId = 0;

      if (portalCase.caseType == 'GENERAL') {
        caseService.cancelCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })

      }
      if (portalCase.caseType == 'COMPLAINT') {

        complainCaseService.cancelComplaintCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })

      }

      if (portalCase.caseType == 'AUTHORIZATION') {
        authorizationCaseService.cancelAuthorizationCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })
      }

      if (portalCase.caseType == 'MOVEMENT_CERTIFICATE') {
        movementCertificateCaseService.cancelMovementCertificateCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })
      }

      if (portalCase.caseType == 'BTI') {
        btiCaseService.cancelBTICase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })
      }

      if (portalCase.caseType == 'IPR') {
        iprCaseService.cancelIPRCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })
      }

      if (portalCase.caseType == 'CUSTOMS_WAREHOUSE') {
        customsWarehouseCaseService.cancelCustomsWarehouseCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })
      }

      if (portalCase.caseType == 'SIMPLIFIED_PROCEDURE') {
        simplifiedProcedureCaseService.cancelSimplifiedProcedureCase({
          id: portalCase.id
        }, function (data) {
          if (!$scope.filter.type) {
            $scope.filter.type = "";
          }
          if (!$scope.filter.status) {
            $scope.filter.status = "";
          }
          if ($scope.filter.subType) {
            caseSubTypeId = $scope.filter.subType.id;
          }

          $window.location.reload();
          caseService.getRegisteredUserFilteredCases({
            status: $scope.filter.status,
            type: $scope.filter.type,
            subTypeId: caseSubTypeId

          }, function (data) {
            setCasesList(data);
          })
        })
      }
    };


    // Complain Case
    $scope.createComplainCase = function () {
      $location.path("/web_portal/web_portal_home_page/create_complain_case");
      initEntity();

      $scope.complainCaseEntity = {};
      $scope.complainCaseEntity.complaintCase = {};
      $scope.complainCaseEntity.declarations = [];
      $scope.complainCaseEntity.complaintCase.caseType = 'COMPLAINT';
      $scope.complainCaseEntity.complaintCase.caseStatus = 'DRAFT';
      $scope.complainCaseEntity.complaintCase.customsDeclarationDecision = true;
      $scope.complaintCaseDecisionEntity.complaintCase.customsDeclarationDecision = true;
      $scope.complaintCaseDecisionEntity.complaintCase = {};
      $scope.complaintCaseDecisionEntity.decision = {};
      $scope.complaintCaseDecisionEntity.complaintCase.caseType = 'COMPLAINT';
      $scope.complaintCaseDecisionEntity.complaintCase.caseStatus = 'DRAFT';


    };


    $scope.saveNewComplainCaseSad = function () {
      $scope.complainCaseEntity.complaintCase.caseType = 'COMPLAINT';
      $scope.complainCaseEntity.complaintCase.caseStatus = 'DRAFT';
      $scope.complainCaseEntity.complaintCase.customsDeclarationDecision = true;
      complainCaseService.createComplainCase($scope.complainCaseEntity, function (data) {
        $scope.complainCaseEntity.complaintCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_complaint_case/" + data.id);
      })
    };

    $scope.saveNewComplainCaseDecision = function () {
      $scope.complaintCaseDecisionEntity.complaintCase.caseType = 'COMPLAINT';
      $scope.complaintCaseDecisionEntity.complaintCase.caseStatus = 'DRAFT';
      $scope.complaintCaseDecisionEntity.complaintCase.customsDeclarationDecision = false;
      complainCaseService.createComplainCaseDecision($scope.complaintCaseDecisionEntity, function (data) {
        $scope.complaintCaseDecisionEntity.complaintCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_complaint_case/" + data.id);
      })
    };

    $scope.removeDeclarations = function (item) {
      var index = item;
      $scope.complainCaseEntity.declarations.splice(index, 1);
    };

    $scope.removeAuthorizationTariff = function (item) {
      var index = item;
      $scope.authorizationCaseEntity.authorizationTariffList.splice(index, 1);
    };

    //  Authorization Case

    $scope.createAuthorizationCase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_authorization_case");
      $scope.about = {};
      $scope.authorizationCaseEntity = {};
      $scope.authorizationCaseEntity.authorizationCase = {};
      $scope.authorizationCaseEntity.authorizationCase.caseType = 'AUTHORIZATION';
      $scope.authorizationCaseEntity.authorizationTariffList = [];
      $scope.authorizationCaseEntity.authorizationCase.caseStatus = 'DRAFT';
      $scope.authorizationTariff = {};
      $scope.authorizationTariffCounter = 0;
    };


    $scope.saveNewAuthorizationCase = function () {
      $scope.authorizationCaseEntity.authorizationCase.caseType = 'AUTHORIZATION';
      $scope.authorizationCaseEntity.authorizationCase.caseStatus = 'DRAFT';
      authorizationCaseService.createAuthorizationCase($scope.authorizationCaseEntity, function (data) {
        $scope.authorizationCaseEntity.authorizationCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_authorization_case/" + data.id);
      })
    };


    $scope.addAuthorizationTariff = function (authorizationTariff) {

        authorizationCaseService.findTariffByCode({code: authorizationTariff.code}, function (data) {
          if(data.id){
            $scope.authorizationTariff.tariff = data;
            $scope.authorizationTariff.description = data.labelSQ;
            $scope.foundAuthorizationTafiff = "";
          }else{
            $scope.authorizationTariff.tariff = null;
            $scope.foundAuthorizationTafiff = "portal.tariff_not_found";
          }
          if(authorizationTariff.tariff && authorizationTariff.tariff.id){
            $scope.authorizationCaseEntity.authorizationTariffList.push(authorizationTariff);
            $scope.authorizationTariff = {};
          }
          else{
            Messages.error('portal.invalid_tariff');
          }
        });
      };

      // $scope.authorizationTariff.tariff = null;
      // $scope.authorizationTariff.quantity = null;
      // $scope.authorizationTariff.value = null;


    $scope.searchTariffByCode = function (code) {
      authorizationCaseService.findTariffByCode({code: code}, function (data) {
        if(data.id){
          $scope.authorizationTariff.tariff = data;
          $scope.authorizationTariff.description = data.labelSQ;
          $scope.foundAuthorizationTafiff = "";
        }else{
          $scope.authorizationTariff.tariff = null;
          $scope.foundAuthorizationTafiff = "portal.tariff_not_found";
        }
      });
    };

    $scope.downloadAuthorizationTypeTemplateAttachment = function (templateId) {
      if(templateId) {
        Downloader.download('/data/rest/portal_attachments/get_authorization_type_template/' + templateId);
      }
    };

    $scope.downloadGoodsTypeTemplateAttachment = function (templateId) {
      if(templateId) {
        Downloader.download('/data/rest/portal_attachments/get_goods_type_template/' + templateId);
      }
    };


    $scope.saveNewAuthorizationCaseForAuthorization = function () {
      $scope.authorizationCaseEntity.authorizationCase.caseType = 'AUTHORIZATION';
      $scope.authorizationCaseEntity.authorizationCase.caseStatus = 'DRAFT';
      $scope.authorizationCaseEntity.authorizationCase.licence = false;
      authorizationCaseService.createAuthorizationCase($scope.authorizationCaseEntity, function (data) {
        $scope.authorizationCaseEntity.authorizationCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_authorization_case/" + data.id);
      })
    };

    $scope.saveNewAuthorizationCaseForLicence = function () {
      $scope.authorizationCaseLicenceEntity.authorizationCase.caseType = 'AUTHORIZATION';
      $scope.authorizationCaseLicenceEntity.authorizationCase.caseStatus = 'DRAFT';
      $scope.authorizationCaseLicenceEntity.authorizationCase.licence = true;
      authorizationCaseService.createAuthorizationCaseForLicence($scope.authorizationCaseLicenceEntity, function (data) {
        $scope.authorizationCaseLicenceEntity.authorizationCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_authorization_case/" + data.id);
      })
    };

    $scope.createMovementCertificateCase = function () {
      initEntity();
        $location.path("/web_portal/web_portal_home_page/create_movement_certificate_case");
      $scope.about = {};
      $scope.movementCertificateCaseEntity = {};
      $scope.movementCertificateCaseEntity.movementCertificateCase = {};
      $scope.movementCertificateCaseEntity.movementCertificateGoodsList = [];
      $scope.movementCertificateCaseEntity.movementCertificateInvoicesList = [];
      $scope.movementCertificateCaseEntity.movementCertificateCase.caseType = 'MOVEMENT_CERTIFICATE';
      $scope.movementCertificateCaseEntity.movementCertificateCase.caseStatus = 'DRAFT';

      $scope.movementCertificateGoods = {};
      $scope.movementCertificateInvoices ={};

      // $scope.authorizationTariffCounter = 0;
      $scope.movementCertificateGoodsCounter = 0;

    };

    $scope.saveNewMovementCertificateCase = function () {
      var movementCertificate = $scope.movementCertificateCaseEntity.movementCertificate;
      if (movementCertificate && movementCertificate.massInOther != null && movementCertificate.massInOther !== ''
          && !(movementCertificate.measurementUnit && movementCertificate.measurementUnit.code)) {
        Messages.error('portal.measurement_unit_other_required');
        return;
      }

      $scope.movementCertificateCaseEntity.movementCertificateCase.caseType = 'MOVEMENT_CERTIFICATE';
      $scope.movementCertificateCaseEntity.movementCertificateCase.caseStatus = 'DRAFT';

      $scope.movementCertificateCaseEntity.movementCertificate.declarationNumber  = $scope.sad.declarationNumber;
      $scope.movementCertificateCaseEntity.movementCertificate.declarationOffice  = $scope.sad.declarationOffice;
      $scope.movementCertificateCaseEntity.movementCertificate.declarationYear  = $scope.sad.declarationYear;


      movementCertificateCaseService.createMovementCertificateCase($scope.movementCertificateCaseEntity, function (data) {
        $scope.movementCertificateCaseEntity.movementCertificateCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_movement_certificate_case/" + data.id);
      });
    };

    $scope.addMovementCertificateGoods = function (movementCertificateGoods) {
      var counter = $scope.movementCertificateCaseEntity.movementCertificateGoodsList.length;
      if(movementCertificateGoods.itemNumber){
        $scope.movementCertificateCaseEntity.movementCertificateGoodsList.splice(movementCertificateGoods.itemNumber-1, 1);

      }else{
        movementCertificateGoods.itemNumber = $scope.movementCertificateCaseEntity.movementCertificateGoodsList.length+1;
      }

      $scope.movementCertificateCaseEntity.movementCertificateGoodsList.splice(movementCertificateGoods.itemNumber-1, 0, movementCertificateGoods);
      $scope.movementCertificateGoods = {};
    };

    $scope.addMovementCertificateInvoices = function (movementCertificateInvoices) {
      $scope.movementCertificateCaseEntity.movementCertificateInvoicesList.push(movementCertificateInvoices);
      $scope.movementCertificateInvoices = {};
    };



    $scope.addNewIprRight = function () {
      $scope.onEditRight = false;
      $scope.editingRightIndex = -1;
      rightScope.rightEntity = {};
      addOrEditRightDialog.show();
    }

    $scope.addNewIprGood = function () {
      $scope.onEditGood = false;
      $scope.editingGoodIndex = -1;
      goodScope.goodEntity = {};
      addOrEditGoodDialog.show();
    }

    $scope.addNewCustomsWarehouseGood = function () {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseGoodsList();
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.warehouseGoodEntity = {};
      $scope.foundWarehouseTariffMessage = '';
      $scope.modalAddOrEditWarehouseGood.show();
    }
      rightScope.ok = function () {
        if ($scope.onEditRight===false) {
          $scope.iprCaseEntity.iprRightsList.push(rightScope.rightEntity);
          Messages.saved();
        } else {
          if ($scope.editingRightIndex !== -1) {
            angular.copy(rightScope.rightEntity, $scope.iprCaseEntity.iprRightsList[$scope.editingRightIndex]);
            Messages.saved();
          } else {
            Messages.error('portal.error');
          }
        }
        addOrEditRightDialog.hide();
        $scope.onEditRight=false;
      }


      rightScope.cancel = function () {
        addOrEditRightDialog.hide();
      };

    goodScope.ok = function () {
      if ($scope.onEditGood===false) {
        $scope.iprCaseEntity.iprGoodsList.push(goodScope.goodEntity);
        Messages.saved();
      } else {
        if ($scope.editingGoodIndex !== -1) {
          angular.copy(goodScope.goodEntity, $scope.iprCaseEntity.iprGoodsList[$scope.editingGoodIndex]);
          Messages.saved();
        } else {
          Messages.error('portal.error');
        }
      }
      addOrEditGoodDialog.hide();
      $scope.onEditGood=false;
    }


    goodScope.cancel = function () {
      addOrEditGoodDialog.hide();
    };



    $scope.addIPRRights = function (iprRights) {
      var counter = $scope.iprCaseEntity.iprRightsList.length;
      if(iprRights.rightNumber){
        $scope.iprCaseEntity.iprRightsList.splice(iprRights.rightNumber-1, 1);

      }else{
        iprRights.rightNumber = $scope.iprCaseEntity.iprRightsList.length+1;
      }

      $scope.iprCaseEntity.iprRightsList.splice(iprRights.rightNumber-1, 0, iprRights);
      $scope.iprRights = {};
    };

    $scope.addIPRGoods = function (iprGoods) {
      var counter = $scope.iprCaseEntity.iprGoodsList.length;
      if(iprGoods.rightNumber){
        $scope.iprCaseEntity.iprGoodsList.splice(iprGoods.rightNumber-1, 1);

      }else{
        iprGoods.rightNumber = $scope.iprCaseEntity.iprGoodsList.length+1;
      }

      $scope.iprCaseEntity.iprGoodsList.splice(iprGoods.rightNumber-1, 0, iprGoods);
      $scope.iprGoods = {};
    };

    // $scope.addCustomsWarehouseGoods = function (warehouseGoods) {
    //   var counter = $scope.iprCaseEntity.iprGoodsList.length;
    //   if(warehouseGoods.rightNumber){
    //     $scope.iprCaseEntity.iprGoodsList.splice(iprGoods.rightNumber-1, 1);
    //
    //   }else{
    //     iprGoods.rightNumber = $scope.iprCaseEntity.iprGoodsList.length+1;
    //   }
    //
    //   $scope.iprCaseEntity.iprGoodsList.splice(iprGoods.rightNumber-1, 0, iprGoods);
    //   $scope.iprGoods = {};
    // };


    $scope.removeIPRRights = function (item) {
      var index = item;
      $scope.iprCaseEntity.iprRightsList.splice(index, 1);
      if(index < $scope.iprCaseEntity.iprRightsList.length){
        var i = index;
        while(i<$scope.iprCaseEntity.iprRightsList.length){
          $scope.iprCaseEntity.iprRightsList[i].itemNumber = i+1;
          i++;
        }
      }
    };

    $scope.removeIPRGoods = function (item) {
      var index = item;
      $scope.iprCaseEntity.iprGoodsList.splice(index, 1);
      if(index < $scope.iprCaseEntity.iprGoodsList.length){
        var i = index;
        while(i<$scope.iprCaseEntity.iprGoodsList.length){
          $scope.iprCaseEntity.iprGoodsList[i].itemNumber = i+1;
          i++;
        }
      }
    };

    $scope.removeCustomsWarehouseGoods = function (item) {
      $scope.ensureCustomsWarehouseGoodsList();
      var index = item;
      $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList.splice(index, 1);
      if(index < $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList.length){
        var i = index;
        while(i<$scope.customsWarehouseCaseEntity.customsWarehouseGoodsList.length){
          $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList[i].itemNumber = i+1;
          i++;
        }
      }
    };

    $scope.editIprRight = function (item) {
      $scope.onEditRight=true;
      var index = item;
      $scope.editingRightIndex = index;
      //rightScope.rightEntity = $scope.iprCaseEntity.iprRightsList[index];
      rightScope.rightEntity = angular.copy($scope.iprCaseEntity.iprRightsList[index]);
      addOrEditRightDialog.show();
    };

    $scope.editIprGood = function (item) {
      $scope.onEditGood=true;
      var index = item;
      $scope.editingGoodIndex = index;
      goodScope.goodEntity = angular.copy($scope.iprCaseEntity.iprGoodsList[index]);
      addOrEditGoodDialog.show();
    };

    $scope.editCustomsWarehouseGood = function (item) {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseGoodsList();
      $scope.onEditWarehouseGood = true;
      var index = item;
      $scope.editingWarehouseGoodIndex = index;
      $scope.warehouseGoodEntity = angular.copy($scope.customsWarehouseCaseEntity.customsWarehouseGoodsList[index]);
      $scope.foundWarehouseTariffMessage = '';
      if ($scope.warehouseGoodEntity.tariffCode) {
        authorizationCaseService.findTariffByCode({code: $scope.warehouseGoodEntity.tariffCode}, function (data) {
          if (data.id) {
            $scope.warehouseGoodEntity.tariff = data;
          }
        });
      }
      $scope.modalAddOrEditWarehouseGood.show();
    };



    $scope.removeMovementCertificateGoods = function (item) {
      var index = item;
      $scope.movementCertificateCaseEntity.movementCertificateGoodsList.splice(index, 1);
      if(index < $scope.movementCertificateCaseEntity.movementCertificateGoodsList.length){
        var i = index;
        while(i<$scope.movementCertificateCaseEntity.movementCertificateGoodsList.length){
          $scope.movementCertificateCaseEntity.movementCertificateGoodsList[i].itemNumber = i+1;
          i++;

        }
      }

    };

    $scope.removeMovementCertificateInvoices = function (item) {
      var index = item;
      $scope.movementCertificateCaseEntity.movementCertificateInvoicesList.splice(index, 1);
    };

    $scope.editMovementCertificateGoods = function (item) {
      var index = item;
      $scope.movementCertificateGoods = $scope.movementCertificateCaseEntity.movementCertificateGoodsList[index];
      // $scope.movementCertificateCaseEntity.movementCertificateGoodsList.splice(index, 1);
      // for (i = 0; i < $scope.movementCertificateCaseEntity.movementCertificateGoodsList; i++) {
      //   $scope.movementCertificateCaseEntity.movementCertificateGoodsList[i].itemNumber = i+1;
      // }
    };

    $scope.checkCustomsDeclaration  = function (sad){
      var dto = {};
      dto.declaration = sad;
      dto.movementCertificateCase = $scope.movementCertificateCaseEntity.movementCertificateCase;

      dto.forCompany = $scope.forCompany;
      dto.forIndividual = $scope.forIndividual;
      dto.allowIndividualEdit = $scope.allowIndividualEdit;
      dto.allowCompanyEdit = $scope.allowCompanyEdit;

      movementCertificateCaseService.loadCustomsDeclarationData(dto, function (data){
        $scope.movementCertificateCaseEntity = data;

      })


    }

    $scope.createBTICase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_bti_case");
      $scope.about = {};
      $scope.btiCaseEntity = {};
      $scope.btiCaseEntity.btiCase = {};
      $scope.btiCaseEntity.btiCase.caseType = 'BTI';
      $scope.btiCaseEntity.btiCase.caseStatus = 'DRAFT';


    };

    $scope.saveNewBTICase = function () {
      $scope.btiCaseEntity.btiCase.caseType = 'BTI';
      $scope.btiCaseEntity.btiCase.caseStatus = 'DRAFT';

      btiCaseService.createBTICase($scope.btiCaseEntity, function (data) {
        $scope.btiCaseEntity.btiCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_bti_case/" + data.id);
      });
    };


    $scope.createIPRCase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_ipr_case");
      $scope.about = {};
      $scope.iprCaseEntity = {};
      $scope.iprCaseEntity.iprCase = {};
      $scope.iprCaseEntity.iprCase.caseType = 'IPR';
      $scope.iprCaseEntity.iprCase.caseStatus = 'DRAFT';
      $scope.iprRights = {};
      $scope.iprGoods = {};
    };

    $scope.saveNewIPRCase = function () {
      $scope.iprCaseEntity.iprCase.caseType = 'IPR';
      $scope.iprCaseEntity.iprCase.caseStatus = 'DRAFT';


      iprCaseService.createIPRCase($scope.iprCaseEntity, function (data) {
        $scope.iprCaseEntity.iprCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_ipr_case/" + data.id);
      });
    };

    $scope.createCustomsWarehouseCase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_customs_warehouse_case");
      $scope.about = {};
      $scope.customsWarehouseCaseEntity = {};
      $scope.customsWarehouseCaseEntity.customsWarehouseCase = {};
      $scope.customsWarehouseCaseEntity.customsWarehouseCase.caseType = 'CUSTOMS_WAREHOUSE';
      $scope.customsWarehouseCaseEntity.customsWarehouseCase.caseStatus = 'DRAFT';
      $scope.customsWarehouseCaseEntity.customsWarehouse = {};
      $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = [];
      $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = [];
    };

    $scope.saveNewCustomsWarehouseCase = function () {
      if (!SimplifiedProcedureValidation.validateCustomsWarehouseAndNotify(
        $scope.customsWarehouseCaseEntity && $scope.customsWarehouseCaseEntity.customsWarehouse
      )) {
        return;
      }

      $scope.customsWarehouseCaseEntity.customsWarehouseCase.caseType = 'CUSTOMS_WAREHOUSE';
      $scope.customsWarehouseCaseEntity.customsWarehouseCase.caseStatus = 'DRAFT';


      customsWarehouseCaseService.createCustomsWarehouseCase($scope.customsWarehouseCaseEntity, function (data) {
        $scope.customsWarehouseCaseEntity.customsWarehouseCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_customs_warehouse_case/" + data.id);
      });
    };

    $scope.createSimplifiedProcedureCase = function () {
      initEntity();
      $location.path("/web_portal/web_portal_home_page/create_simplified_procedure_case");
      $scope.about = {};
      $scope.simplifiedProcedureCaseEntity = {};
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase = {};
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.caseType = 'SIMPLIFIED_PROCEDURE';
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.caseStatus = 'DRAFT';
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedure = {};
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureGoodsList = [];
    };

    $scope.saveNewSimplifiedProcedureCase = function () {
      if (!SimplifiedProcedureValidation.validateAndNotify(
        $scope.simplifiedProcedureCaseEntity && $scope.simplifiedProcedureCaseEntity.simplifiedProcedure
      )) {
        return;
      }

      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.caseType = 'SIMPLIFIED_PROCEDURE';
      $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase.caseStatus = 'DRAFT';

      simplifiedProcedureCaseService.createSimplifiedProcedureCase($scope.simplifiedProcedureCaseEntity, function (data) {
        $scope.simplifiedProcedureCaseEntity.simplifiedProcedureCase = data;
        $location.path("/web_portal/web_portal_home_page/edit_simplified_procedure_case/" + data.id);
      });
    };

  }]);
